import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import { useMemo } from 'react';
import CardImage from './card-image';
import CardTerminal from './card-terminal';
import CardCode from './card-code';
import { Segmented } from 'antd';
import { Tooltip } from 'antd';
import { markdownToPlainText } from '@shared/utils';
import copy from 'copy-to-clipboard';
import Other from '@/common/helper/other';
import { useEffect } from 'react';
import Code from './components/code';

const CardSandbox = observer((props) => {
  const {
    event,
    mcpStore,
    currentDark,
    callbackTabs,
  } = props;

  const tabList = useMemo(() => {
    // const list = [
    //   "图表结果",
    //   "终端",
    //   "源代码",
    //   "工具参数",
    // ];

    const list = [];
    try{
      if(event.detail?.results?.[0]?.contentType == "image"){
        list.push("图表结果");
      }
    } catch(e){}

    if(event.content2){
      list.push("终端");
    }

    if(event.content){
      list.push("源代码");
    }

    const paramsText = mcpStore.getNodeParamsText(event);
    if (paramsText) {
      list.push('工具参数');
    }

    return list;
  }, [event]);

  const [alignValue, setAlignValue] = useState('图表结果');

  // 显示最新结果
  useEffect(() => {
    if(!tabList.length){
      return;
    }
    setAlignValue(tabList[0]);
  }, [tabList.length]);

  const onTabChange = (value) => {
    setAlignValue(value);
    callbackTabs && callbackTabs(value);
  }

  const renderCard = () => {
    if(alignValue == "图表结果"){
      return (
        <CardImage 
          data={event.detail?.results?.[0]?.url || ""}
          event={event}
          />
      )
    }

    if(alignValue == "终端"){
      const ansiStyles = {
        '0': 'font-weight: normal; color: inherit;',
        '1': 'font-weight: bold;',
        '32': 'color: green;',
        '34': 'color: blue;'
      };
      const ansiRegex = /\x1b\[([0-9;]+)m/g;
      const html = event?.content2.replace(ansiRegex, (match, str) => {
        const styles = str.split(';').map(c => ansiStyles[c] || '').join(' ');
        return `<span style="${styles}" >`;
      }).replace(/\x1b\[0m/g, '</span >').replace(/[\n\r]/g, '<br />');

      return (
        <CardTerminal
          data={html} 
          event={event} 
          /> 
      )
    }

    if(alignValue == "源代码"){
      const str = event.content || '';
      const code = (str.startsWith('```') ? '' : ('```' + (event.language || 'python') + '\n'))
        + str 
        + (str.endsWith('```') ? '' : '\n```');

      return (
        <CardCode
          data={code} 
          tool="execute"
          event={event} 
          /> 
      )
    }

    if(alignValue == "工具参数"){
      return (
        <div className={[
          "px-24px pr-16px mr-4px my-16px whitespace-pre-wrap text-14px text-black  leading-24px break-all",
          "overflow-x-hidden overflow-y-auto",
          currentDark ? 'scrollbar-dark' : 'scrollbar'
        ]}>
          <Code
            data={'```json\n' + mcpStore.getNodeParamsText(event)?.trim() + '\n```'}
            className="whitespace-pre-wrap"
            syntaxClassName="language-json"
            light={false}
            showLineNumbers={true}
          />
          {/* {mcpStore.getNodeParamsText(event)} */}
        </div>
      )
    }

    return null;
  }

  const copyFile = () => {
    let text = event.content;
    if (alignValue === '终端') {
      text = event.content2.replace(/<br ?\/?>/gi, '\n')
    }
    const plainText = (text);
    const copied = copy(plainText);
    copied && Other.toast('复制成功', "success");
  }

  return (
    <>
      <div className={`py-16px px-24px flex items-center justify-between ${alignValue == "源代码" ? 'bg-[#282c34] rounded-t-12px' : ''}`}>
        <div className="tabs">
          <Segmented
            value={alignValue}
            onChange={onTabChange}
            options={tabList}
          />
        </div>
        {
          [
            // "终端",
            "源代码",
          ].includes(alignValue)? (
            <div
              style={{
                boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.12)',
              }}
              className="h-28px w-48px text-center leading-28px cursor-pointer rounded-6px bg-[#444] hover:bg-[#666] text-14px text-[#fff] border-1px border-[rgba(255,255,255,0.10)]"
              onClick={() => {
                copyFile()
              }}
            >
              复制
            </div>
          ) : null
        }
      </div>

      {renderCard()}
    </>
  )
});
export default CardSandbox;